import { UI_LANGUAGES } from '../constants'

export const getEnvUILangOptions = () => {
  const envUILanguageValues = process.env.REACT_APP_UI_LANGUAGES?.split(',')

  const langOptions = envUILanguageValues
    ? UI_LANGUAGES.filter((uiLang) => {
        return envUILanguageValues?.includes(uiLang.value)
      })
    : UI_LANGUAGES

  return langOptions
}

// TODO: can be removed when admin tool is in use
export const isAdminToolUsed = () =>
  process.env.REACT_APP_USE_ADMIN_TOOL === 'true'

// TODO: can be removed when admin tool is in use
export const areAdminToolNewsUsed = () =>
  process.env.REACT_APP_USE_ADMIN_TOOL_NEWS === 'true'
